// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_GetbyidResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos_servicos/getByID
 *
 * Returns a single compromisso_servico with its related orcamento_servico.
 *
 * Data shape:
 * - compromisso_servico: Full compromissos_servicos record with status_label
 * - orcamento_servico: Full orcamentos_servicos record with joins (servico_label, status_label, tipo_label)
 *
 * @see Compromissos_servicos_model::getByID()
 * @see Orcamentos_servicos_model::carregaOrcamentoServicoPorID()
 */
import type { CompromissosServicos_GetbyidCompromissoServicoRow } from './CompromissosServicos_GetbyidCompromissoServicoRow'
import type { CompromissosServicos_GetbyidOrcamentoServicoRow } from './CompromissosServicos_GetbyidOrcamentoServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface CompromissosServicos_GetbyidResponseDados {
compromisso_servico: CompromissosServicos_GetbyidCompromissoServicoRow
orcamento_servico: CompromissosServicos_GetbyidOrcamentoServicoRow
}

export type CompromissosServicos_GetbyidResponse = ApiResponse<CompromissosServicos_GetbyidResponseDados>;

registerResponseContract('CompromissosServicos_GetbyidResponse', {
  compromisso_servico: {
    type: 'object',
    required: false,
    fields: {
      compromisso_servico_id:            { type: 'number',  required: false },
      compromisso_id:                    { type: 'number',  required: false },
      orcamento_servico_id:              { type: 'number',  required: false },
      compromisso_servico_status:        { type: 'number',  required: false },
      compromisso_servico_qtd:           { type: 'number',  required: false },
      compromisso_servico_valor:         { type: 'number',  required: false },
      compromisso_servico_data_cadastro: { type: 'string',  required: false },
      compromisso_servico_observacao:    { type: 'string',  required: false },
      status_label:                      { type: 'string',  required: false },
    },
  },
  orcamento_servico: {
    type: 'object',
    required: false,
    fields: {
      orcamento_servico_id:            { type: 'number',  required: false },
      orcamento_id:                    { type: 'number',  required: false },
      servico_id:                      { type: 'number',  required: false },
      servico_valor:                   { type: 'number',  required: false },
      orcamento_servico_qtd:           { type: 'number',  required: false },
      orcamento_servico_user_id:       { type: 'string',  required: false },
      orcamento_servico_tipo:          { type: 'number',  required: false },
      orcamento_servico_status:        { type: 'number',  required: false },
      orcamento_servico_data_cadastro: { type: 'string',  required: false },
      servico_label:                   { type: 'string',  required: false },
      status_label:                    { type: 'string',  required: false },
      tipo_label:                      { type: 'string',  required: false },
    },
  },
})
